import React from 'react';
import ResetPasswordForm from '../components/common/ResetPasswordForm';

const ResetPasswordPage = () => {
  return <ResetPasswordForm />;
};

export default ResetPasswordPage;